'use client';

import { useEffect, useState } from 'react';

import type { TBreakpoint } from '@/constants';
import { BREAKPOINTS } from '@/constants';

export const useBreakpoints = (breakpoint: TBreakpoint): boolean => {
  const [isBelowBreakpoint, setIsBelowBreakpoint] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia(`(max-width: ${BREAKPOINTS[breakpoint] - 1}px)`);
    const handleChange = () => setIsBelowBreakpoint(mediaQuery.matches);

    handleChange();
    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, [breakpoint]);

  return isBelowBreakpoint;
};
